import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bcc7cb9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = { class: "card-body border-top p-9 pt-2" }
const _hoisted_4 = { class: "row mb-5" }
const _hoisted_5 = { class: "col-lg-6 col-xs-12 fv-row" }
const _hoisted_6 = { class: "row px-3" }
const _hoisted_7 = { class: "col-12 fv-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nama Produk", -1))
const _hoisted_9 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { class: "col-12 fv-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 col-form-label required fw-bold fs-6" }, "Pilih Kategori Produk", -1))
const _hoisted_13 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "col-12 fv-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Deskripsi", -1))
const _hoisted_17 = { class: "col-12 fw-row" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "col-12 fv-row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Harga", -1))
const _hoisted_21 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "col-12 fv-row" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Diskon", -1))
const _hoisted_25 = { class: "col-12 fv-row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "PPN", -1))
const _hoisted_27 = { class: "col-12 fv-row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Stok Produk", -1))
const _hoisted_29 = { class: "col-lg-6 col-xs-12 fv-row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row px-3" }, "Upload Foto", -1))
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "row px-3 my-2" }
const _hoisted_33 = ["for"]
const _hoisted_34 = ["name", "id", "onChange"]
const _hoisted_35 = ["src"]
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "img-product-overlay" }
const _hoisted_38 = ["for", "src"]
const _hoisted_39 = ["for", "src", "onClick"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-12 text-danger",
  style: {"text-align":"end"}
}, " Format .jpg dan .png ", -1))
const _hoisted_41 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "name",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Nama Produk",
                  modelValue: _ctx.detail.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.detail.title) = $event))
                }, null, 8, ["modelValue"]),
                (!_ctx.valid.title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.errorsMessage.errortitle), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.detail.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.detail.type) = $event)),
                  placeholder: "Pilih Kategori Produk",
                  mode: "single",
                  "create-option": false,
                  options: _ctx.listType,
                  searchable: true
                }, null, 8, ["modelValue", "options"]),
                (!_ctx.valid.type)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.errorsMessage.errortype), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("textarea", {
                  rows: "5",
                  type: "text",
                  name: "note",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Deskripsi",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detail.description) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.detail.description]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  style: {"border":"1px solid rgba(0, 0, 0, 0.5)","padding":"1em","margin-top":"10px","border-radius":"10px"},
                  innerHTML: _ctx.detail.description
                }, null, 8, _hoisted_18)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_Field, {
                  type: "number",
                  name: "price",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Harga",
                  modelValue: _ctx.detail.price,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.detail.price) = $event))
                }, null, 8, ["modelValue"]),
                (!_ctx.valid.price)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.errorsMessage.errorprice), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_Field, {
                  type: "number",
                  name: "discount",
                  class: "form-control form-control-lg",
                  placeholder: "Isi diskon",
                  modelValue: _ctx.detail.discount,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.detail.discount) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode(_component_Field, {
                  type: "number",
                  name: "discount",
                  class: "form-control form-control-lg",
                  placeholder: "Isi PPN",
                  modelValue: _ctx.detail.tax,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.detail.tax) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_Field, {
                  type: "number",
                  name: "stock",
                  class: "form-control form-control-lg",
                  placeholder: "Isi stok produk",
                  modelValue: _ctx.detail.stock,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.detail.stock) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("img", {
              src: _ctx.deleteImg,
              alt: ""
            }, null, 8, _hoisted_31),
            _createElementVNode("div", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...Array(_ctx.imgCount)].map((x, key) => key), (count) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "img-product",
                  for: `input-file-${count + 1}`,
                  key: `img-product-${count}`
                }, [
                  _createElementVNode("input", {
                    name: `input-file-${count + 1}`,
                    id: `input-file-${count + 1}`,
                    type: "file",
                    class: "product-file",
                    onChange: ($event: any) => (_ctx.handleFileUpload($event, count + 1)),
                    accept: "image/x-png,image/jpeg"
                  }, null, 40, _hoisted_34),
                  (_ctx.urlImage[`url${count + 1}`])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        alt: "file1",
                        class: "img-fluid",
                        src: _ctx.urlImage[`url${count + 1}`]
                      }, null, 8, _hoisted_35))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "img-fluid",
                        src: _ctx.noImg,
                        alt: ""
                      }, null, 8, _hoisted_36)),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("img", {
                      for: `input-file-${count + 1}`,
                      class: "img-product-overlay-button",
                      src: _ctx.deleteImg,
                      alt: ""
                    }, null, 8, _hoisted_38),
                    _createElementVNode("img", {
                      for: `input-file-${count + 1}`,
                      class: "img-product-overlay-button",
                      src: _ctx.uploadImg,
                      onClick: ($event: any) => (_ctx.triggerInputFile(count)),
                      alt: ""
                    }, null, 8, _hoisted_39)
                  ])
                ], 8, _hoisted_33))
              }), 128)),
              _hoisted_40
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("button", {
          class: "btn btn-danger me-3",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push('/superadmin/master-produk')))
        }, " Kembali "),
        _createElementVNode("button", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitData())),
          class: "btn btn-primary"
        }, _hoisted_44)
      ])
    ])
  ], 64))
}